import React, { Component } from 'react'
import AnnualReview from '../data/AnnualReview'
import FlickitySlider from './FlickitySlider'

class AnnualReviewSlider extends Component {
  constructor(props) {
    super(props)

    const years = Object.keys(AnnualReview)

    this.state = {
      years,
    }
  }

  render() {
    return (
      <>
        <div className="flex flex-row justify-center mb-8 md:mb-12">
          {
            this.state.years.map(year => (
              <button
                key={year}
                type="button"
                data-year={year}
                className={`switch-year-btn ${year === this.state.years[0] ? 'bg-blue-500 text-white' : 'text-blue-500 hover:bg-blue-500 hover:text-white'} md:text-xl font-medium border-2 border-blue-500 py-3 md:py-4 px-8 md:px-12 mx-4 focus:outline-none`}
              >
                { year }
              </button>
            ))
          }
        </div>

        {
          this.state.years.map(year => (
            <div
              key={year}
              data-slider-year={year}
              className={`${year === this.state.years[0] ? 'block' : 'hidden'} -mx-4 text-center`}
            >
              <FlickitySlider>
                {
                  AnnualReview[year].map((event, i) => (
                    <div key={i} className="w-1/2 md:w-1/3 mb-12">
                      <div className="mx-4">
                        <img className="block object-fit w-full h-36 mb-4 shadow-xl rounded-sm"
                          src={ `/AnnualReport2017-2018${event.image}` }
                          alt=""
                        />

                        <div className="text-blue-500 text-lg mb-2">
                          { event.dateDisplay[this.props.langKey] }
                        </div>
                        <div className={`${(this.props.langKey === 'zh' ? 'text-left text-justify' : '')}`} dangerouslySetInnerHTML={{ __html: event.title[this.props.langKey] }}></div>
                      </div>
                    </div>
                  ))
                }
              </FlickitySlider>
            </div>
          ))
        }
      </>
    )
  }
}

export default AnnualReviewSlider
